export default __webpack_public_path__ + "static/media/Home_thmb_Nagami.b239bf4b.png";